<div class="scrollbar app">
  <div class="table-responsive tableMx-15">
    <table class="tablest1">
      <thead>
        <tr>
          <th scope="col" translate>lblRole</th>
          <th scope="col" translate>lblEmail</th>
          <th scope="col" translate>lblMobileNo</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="list?.length>0; else load_NotFound_Template">
          <tr *ngFor="let item of list; let i=index">
            <td>
              <ngb-highlight [result]="item.roleName"></ngb-highlight>
            </td>
            <td>
              <ngb-highlight [result]="item.email"></ngb-highlight>
            </td>
            <td>
              <ngb-highlight [result]="item.mobile"></ngb-highlight>
            </td>
          </tr>
        </ng-container>
        <ng-template #load_NotFound_Template>
          <tr>
            <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
          </tr>
        </ng-template>
      </tbody>
    </table>
  </div>
</div>
<div class="p-3 bg-light pp-footer-top-brdr">
<div class="row">
  <div _ngcontent-suh-c228="" class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15 mr-5">
    <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate>lblBack</a>
  </div>
</div>
</div>